// @flow

import { hpfetch, hpfetchWithoutContentType } from '../util';
import type { storefrontType, offeringType } from '../../types';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
  apiResponse,
} from '../apiTypes';
import { CardInstanceType } from '../../components/Shared/HitchpinCard/CardInstanceType';
import { addInstanceType } from '../../library/hitchpin_card/hitchpinCardFunctions';

export const getSingle = (
  id: number,
): Promise<wrappedApiResponseType<storefrontType>> =>
  hpfetch(`storefronts/${id}/`);

export const getAllMyStorefronts = (): djangoModelApiResponse<storefrontType> =>
  hpfetch(`storefronts/mine/`);

export const getFollowed = (): apiResponse<storefrontType> => {
  return hpfetch(`storefronts/public/followed/`).then(response =>
    addInstanceType(response, CardInstanceType.Storefront),
  );
};

export const getSingleBySlug = (
  url: string,
): Promise<wrappedApiResponseType<storefrontType>> => {
  return hpfetch(`storefronts/public/${url}/`).then(response =>
    addInstanceType(response, CardInstanceType.Storefront),
  );
};

export const create = (fields: any) =>
  hpfetch('storefronts/', {
    method: 'POST',
    body: JSON.stringify(fields),
  });

export const deleet = (id: number) =>
  hpfetch(`storefronts/${id}`, {
    method: 'DELETE',
  });

export const updateStorefront = (id: number, fields: any) =>
  hpfetch(`storefronts/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify(fields),
  });

export const getCoverImages = () =>
  hpfetch(`storefronts/cover-images/`, {
    method: 'GET',
  });

export const publicListings = (
  slug: string,
  limit: number = 500,
): djangoModelApiResponse<offeringType> => {
  return hpfetch(
    `storefronts/public/${slug}/listings/?limit=${limit}`,
  ).then(response =>
    addInstanceType(response, CardInstanceType.StorefrontListing),
  );
};

export const privateListings = (
  id: number,
): djangoModelApiResponse<offeringType> =>
  hpfetch(`storefronts/${id}/listings/`).then(response =>
    addInstanceType(response, CardInstanceType.StorefrontListing),
  );

export const publicSold = (
  slug: string,
): djangoModelApiResponse<storefrontType> =>
  hpfetch(`storefronts/public/${slug}/sold/`).then(response =>
    addInstanceType(response, CardInstanceType.StorefrontListing),
  );

export const privateSold = (
  id: number,
): djangoModelApiResponse<storefrontType> =>
  hpfetch(`storefronts/${id}/sold/`).then(response =>
    addInstanceType(response, CardInstanceType.StorefrontListing),
  );

export const getFeed = (
  limit: number = 10,
  offset: number = 0,
): djangoModelApiResponse<offeringType> =>
  hpfetch(`storefronts/public/feed/?limit=${limit}&offset=${offset}`);

export const search = (
  searchBody: any,
  queryString: string,
): djangoModelApiResponse<storefrontType> =>
  hpfetch(`storefronts/public/search/?${queryString}`, {
    method: 'POST',
    body: JSON.stringify(searchBody),
  }).then(response => addInstanceType(response, CardInstanceType.Storefront));

export const updateBrandPhoto = (id: number, image: any, fileName: string) => {
  // const formData = serialize({});
  const formData = new FormData();
  formData.append('image', image, fileName);

  return hpfetchWithoutContentType(`storefronts/${id}/`, {
    body: formData,
    method: 'PATCH',
  });
};

export const follow = (slug: string) =>
  hpfetch(`storefronts/public/${slug}/follow/`, {
    method: 'POST',
  });

export const unfollow = (slug: string) =>
  hpfetch(`storefronts/public/${slug}/unfollow/`, {
    method: 'POST',
  });

export const flyer = (id: number) =>
  hpfetch(`storefronts/${id}/flyer_pdf/`, {
    method: 'GET',
  });

export const postCoverImage = (image: any, fileName: string) => {
  const formData = new FormData();
  formData.append('image', image, fileName);

  return hpfetchWithoutContentType(`storefronts/cover-images/`, {
    body: formData,
    method: 'POST',
  });
};

export const check = (slug: string, hash: any) =>
  hpfetch(`storefronts/public/${slug}/check/`, {
    method: 'POST',
    body: JSON.stringify({ hash }),
  });

export const directory = () =>
  hpfetch(`storefronts/public/minimal/`, {
    method: 'GET',
    body: JSON.stringify(),
  });
